import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=9b9427b6&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=9b9427b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9427b6",
  null
  
)

export default component.exports